window.addEventListener('load', () => {
    const text = "Nos utilizamos cookies essenciais para melhorar sua experiência. Veja mais detalhes em nossa política de privacidade."
    const btnText = "Li e estou de acordo"
    const linkText = "Políticas de Privacidade"
    const link = "#/politicas-de-privacidade"

    cookieConsentPopup(text, btnText, linkText, link, () => {
        helper.insertScriptTag({
            src: "https://www.googletagmanager.com/gtag/js?id=UA-175473140-1"
        })

        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-175473140-1');
    })
})

const helper = {
    insertScriptTag(props) {
        const tag = helper.createTag('script', props)
        document.querySelector('head').append(tag)
    },
    insertNoScriptTag(innerTag, props = {}) {
        const tag = helper.createTag('noscript')
        const inner = helper.createTag(innerTag, props)
        tag.append(inner)
        document.querySelector('body').prepend(tag)
    },
    createTag(name, props = {}) {
        const tag = document.createElement(name)
        Object.entries(props).forEach(([k,v]) => {tag.setAttribute(k,v)})
        return tag
    }
}

function cookieConsentPopup(text, btnText, linkText, link, callback) {
    const getCookies = (name) => {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    const setCookies = (name,value,days) => {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    if(getCookies('cookieAccepted')) {
        callback()
        return
    }

    const d = document.createElement('div')
    const b = document.createElement('button')
    const a = document.createElement('a')
    const t = document.createElement('p')
    d.setAttribute('style', `
        position: fixed;
        bottom: -100%;
        left: 0;
        width: 100%;
        min-height: 78px;
        background: black;
        z-index: 9999;
        display: flex;
        padding: 10px 20px;
        align-items: center;
        flex-wrap: wrap;
        transition: bottom .5s ease-in-out;
    `)
    b.innerText = btnText
    b.setAttribute('style', `
        padding: 8px 15px;
        background: #035BBC;
        border: none;
        color: white;
        cursor: pointer;
    `)
    b.onclick = () => {
        setTimeout(()=>d.style.bottom = '-100%', 200)
        setCookies('cookieAccepted', true)
        callback()
    }

    t.innerText = text
    t.setAttribute('style', `
        margin: 15px 0;
        color: white;
        font-size: 16px;
    `)

    a.innerText = linkText
    a.href = link
    a.setAttribute('style', `
        margin: 0 10px 0 auto;
        color: white;
        font-size: 16px;
        cursor: pointer;
    `)

    d.append(t,a,b)
    document.querySelector('body').appendChild(d)
    setTimeout(()=>d.style.bottom = 0, 500)
}
